import type { ReactNode } from 'react';

/**
 * LegacyLook — keeps the old colors on a page that is kept only as a record.
 *
 * The app's style sheet repaints every legacy color class (the sage `primary`
 * family, charcoal, Electric Mustard and the rest) onto the current tokens.
 * Deprecated and archive pages are the record of how things used to look, so
 * they are left alone (owner ruling D2): every generated repaint rule ends with
 * `:not(.legacy-look *)`, and this wrapper is what puts a page inside it.
 *
 * Mounted at the route in App.tsx, around the DeprecatedBanner and the page, or
 * around an /archive page. `display: contents` so it never changes a layout.
 * The legacy-color check (scripts/checkLegacyColors.ts) reads the same routes
 * to know which pages are never asked to fall.
 */
export function LegacyLook({ children }: { children: ReactNode }) {
  return (
    <div className="legacy-look" style={{ display: 'contents' }}>
      {children}
    </div>
  );
}
